<template>
    <div class="flex flex-col justify-center items-center min-h-screen">
        <img src="@/assets/Next_logo.svg" class="mb-5">
        <h2 class="font-bold text-xl">404</h2>
        <p>Quello che stai cercando non è qui.</p>
        <router-link :to="{name:'Dashboard'}" class="text-next-orange">Torna alla home</router-link>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'NotFound',
    components: {
    },
})
export default class NotFound extends Vue {
}
</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
